import React from 'react'
import PropTypes from 'prop-types'

const t = (key) => (window.I18n ? window.I18n.t(key) : '')

const ClubFeedPopupFooter = ({ settingsUrl, learnMoreUrl, compact }) => {
  const learnMoreHref = learnMoreUrl || t('club_feed.popup_footer.learn_more_url')
  const newTabHint = t('club_feed.popup_footer.opens_in_new_tab')

  return (
    <div className={ `club_feed_popup_footer ${ compact ? 'compact' : '' }` }>
      { settingsUrl && (
        <a href={ settingsUrl }
           target="_blank"
           rel="noopener noreferrer"
           className="club_feed_manage_settings"
        >
          { t('club_feed.popup_footer.manage_settings') }
          <span className="sr-only">{ ` ${ newTabHint }` }</span>
        </a>
      ) }
      <a href={ learnMoreHref } target="_blank" rel="noopener noreferrer" className="learn-more">
        <i className="fa fa-graduation-cap" aria-hidden="true" />
        { ` ${ t('buttons.learn_more') }` }
        <span className="sr-only">{ ` ${ newTabHint }` }</span>
      </a>
    </div>
  )
}

ClubFeedPopupFooter.propTypes = {
  settingsUrl: PropTypes.string,
  learnMoreUrl: PropTypes.string,
  compact: PropTypes.bool,
}

ClubFeedPopupFooter.defaultProps = {
  compact: false,
}

export default ClubFeedPopupFooter
